import Component from 'flarum/common/Component';
import Tooltip from 'flarum/common/components/Tooltip';
import app from 'flarum/forum/app';
import username from 'flarum/common/helpers/username';
import StartConversationModal from "./StartConversationModal";

export default class UserPageButton extends Component {
  pageUser = null;

  oninit(vnode) {
    this.pageUser = vnode.attrs.currentUser || app.current.get('user');
  }

  view() {
    return (
      <span className="whisper-message-button"
        onclick={this.startConversation.bind(this)}
      >
        <Tooltip text={app.translator.trans('kyrne-whisper.forum.chat.chat_with', { username: username(this.pageUser) })}>
          <i class="fas fa-envelope"></i>
        </Tooltip>
      </span>
    );
  }

  startConversation(e)
  {
    e.preventDefault();
    
    app.modal.show(StartConversationModal, {
      conversations: app.cache.conversations,
      messages: app.cache.messages,
      conversationsRecipient: this.pageUser
    });

    $('.WhisperMessagesDropdown').trigger('shown.bs.dropdown');
  }
}
